export default __webpack_public_path__ + "static/29-weapon-f4f20fada5f53cc8a0254b518163857e.png";